// extracted by mini-css-extract-plugin
export var scrollArea = "_nv-0";